import React from "react";
import Grid from "@material-ui/core/Grid";
import PhoneRoundedIcon from "@material-ui/icons/PhoneRounded";
import EmailRoundedIcon from "@material-ui/icons/EmailRounded";
import FooterLogo from "../assets/imgs/maven24.com-logo.png";
import tickIcon from "../assets/imgs/tickIcon.svg";

function Footer() {
  const date = new Date();
  return (
    <>
      <div className="ExpansionFooterContainer">
        <div className="ExpansionContainer">
          <Grid container spacing={3}>
            <Grid item md={4} sm={4} xs={12}>
              <div className="FooterTop">
                <h1>Masjid Baitus Salam/MUNA Center of East Flatbush</h1>
                <p>We are 501(c)(3) tax-exempted organization.</p>
                <p>
                  Tax ID 84-3616485 <img className="tickIcon" src={tickIcon} />{" "}
                </p>
              </div>
            </Grid>

            <Grid item md={4} sm={4} xs={12}>
              <div className="FooterTop">
                <h1>Address</h1>
                <p>167 East 43rd ST</p>
                <p>Brooklyn, NY 11203</p>
              </div>
            </Grid>

            <Grid item md={4} sm={4} xs={12}>
              <div className="FooterTop">
                <h1>Contact</h1>
                <p>
                  <PhoneRoundedIcon />
                  +1 (718) 306-7288
                </p>
                <p>
                  <EmailRoundedIcon />
                  baitussalam167@gmail.com
                </p>
              </div>
            </Grid>
          </Grid>
        </div>

        <div className="FooterTosSection">
          <div className="ExpansionContainer FooterTosSectionInner">
            <div>
              <a href="https://myababil.com/terms">Terms of Services</a>
              <span>|</span>
              <a href="https://myababil.com/privacy">Privacy Policy</a>
            </div>
            <div className="CraftedText">Crafted with ❤ in islam</div>
          </div>
        </div>
      </div>

      <div className="FooterBottom">
        <div className="ExpansionContainer FooterBottomSectionInner">
          <p>© {date?.getFullYear()} Maven24. ALL RIGHT RESERVED</p>
          <p className="footerLogo">
            Powered by{" "}
            <a href="https://www.maven24.com/store?utm_source=web&utm_medium=web-masjid&utm_campaign=web-m24-footer">
              <img src={FooterLogo} />
            </a>
          </p>
          <div className="VisitText">
            Visit us -{" "}
            <a
              href="https://www.maven24.com/store?utm_source=web&utm_medium=web-masjid&utm_campaign=web-m24-footer"
              target="blank"
            >
              www.maven24.com
            </a>
          </div>
        </div>
      </div>
    </>
  );
}

export default Footer;
